webpackJsonp([139164803332356],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(49);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectImage = function ProjectImage(_ref) {
	  var src = _ref.src;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.box },
	      _react2.default.createElement('img', { className: _stylesModule2.default.fit, alt: 'Peter Miles Studio', src: src })
	    )
	  );
	};
	
	ProjectImage.propTypes = {
	  src: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProjectImage;
	module.exports = exports['default'];

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-ProjectImage----styles-module---wrapper---1uB88","box":"src-components-ProjectImage----styles-module---box---2n14X","fit":"src-components-ProjectImage----styles-module---fit---rutPY"};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(57);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ProjectImage = __webpack_require__(42);
	
	var _ProjectImage2 = _interopRequireDefault(_ProjectImage);
	
	var _stylesModule = __webpack_require__(303);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var xDown = null;
	var yDown = null;
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Project);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentImage: 0,
	      index: null,
	      nextSlug: null,
	      prevSlug: null
	    }, _this.onKeyPress = function (e) {
	      var key = e.keyCode ? e.keyCode : e.which;
	      if (key === 39) _this.goToNext();
	      if (key === 37) _this.goToPrev();
	    }, _this.goToNext = function (state) {
	      var data = _this.props.data;
	      var _this$state = _this.state,
	          currentImage = _this$state.currentImage,
	          nextSlug = _this$state.nextSlug;
	      var images = data.contentfulProject.images;
	
	
	      if (images && currentImage < images.length - 1) {
	        _this.setState({
	          currentImage: currentImage + 1
	        });
	      } else {
	        (0, _gatsbyLink.navigateTo)({
	          pathname: '/' + nextSlug,
	          state: state
	        });
	      }
	    }, _this.goToPrev = function () {
	      var _this$state2 = _this.state,
	          currentImage = _this$state2.currentImage,
	          prevSlug = _this$state2.prevSlug;
	
	
	      if (currentImage > 0) {
	        _this.setState({
	          currentImage: currentImage - 1
	        });
	      } else {
	        (0, _gatsbyLink.navigateTo)({
	          pathname: '/' + prevSlug
	        });
	      }
	    }, _this.handleClick = function () {
	      _this.goToNext();
	    }, _this.handleTouchStart = function (evt) {
	      var firstTouch = evt.touches[0];
	      xDown = firstTouch.clientX;
	      yDown = firstTouch.clientY;
	    }, _this.handleTouchMove = function (evt) {
	      evt.preventDefault();
	      if (!xDown || !yDown) {
	        return;
	      }
	
	      var xUp = evt.touches[0].clientX;
	      var yUp = evt.touches[0].clientY;
	
	      var xDiff = xDown - xUp;
	      var yDiff = yDown - yUp;
	
	      if (Math.abs(xDiff) > Math.abs(yDiff)) {
	        if (xDiff > 0) {
	          _this.goToNext();
	        } else {
	          _this.goToPrev();
	        }
	      }
	      xDown = null;
	      yDown = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Project.prototype.componentWillMount = function componentWillMount() {
	    var data = this.props.data;
	
	    var projects = data.allContentfulProject.edges.map(function (_ref) {
	      var node = _ref.node;
	      return node;
	    });
	    var thisSlug = data.contentfulProject.slug;
	    var thisIndex = projects.findIndex(function (_ref2) {
	      var slug = _ref2.slug;
	      return thisSlug === slug;
	    });
	
	    var imageFeed = projects.filter(function (project) {
	      return !!project.images && project.images.length > 0;
	    });
	    var feedIndex = imageFeed.findIndex(function (_ref3) {
	      var slug = _ref3.slug;
	      return thisSlug === slug;
	    });
	    var lastProject = imageFeed.length - 1;
	
	    this.setState({
	      index: thisIndex + 1,
	      nextSlug: feedIndex !== lastProject ? imageFeed[feedIndex + 1].slug + '/images/' : imageFeed[0].slug + '/images/',
	      prevSlug: feedIndex !== 0 ? imageFeed[feedIndex - 1].slug + '/images/' : imageFeed[lastProject].slug + '/images/'
	    });
	  };
	
	  Project.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('keyup', this.onKeyPress);
	
	    document.addEventListener('touchstart', this.handleTouchStart, false);
	    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
	  };
	
	  Project.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keyup', this.onKeyPress);
	    document.removeEventListener('touchstart', this.handleTouchStart, false);
	    document.removeEventListener('touchmove', this.handleTouchMove, false);
	  };
	
	  Project.prototype.render = function render() {
	    var data = this.props.data;
	    var _state = this.state,
	        currentImage = _state.currentImage,
	        index = _state.index;
	    var _data$contentfulProje = data.contentfulProject,
	        buyLink = _data$contentfulProje.buyLink,
	        client = _data$contentfulProje.client,
	        images = _data$contentfulProje.images,
	        slug = _data$contentfulProje.slug,
	        title = _data$contentfulProje.title;
	
	
	    var imageToShow = images && images[currentImage];
	
	    return _react2.default.createElement(
	      'div',
	      { key: slug },
	      _react2.default.createElement(_Header2.default, {
	        anchor: slug,
	        background: true,
	        buy: buyLink,
	        client: client,
	        id: index,
	        slug: '/' + slug,
	        title: title,
	        total: data.allContentfulProject.edges.length
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _stylesModule2.default.wrapper,
	          onClick: this.handleClick,
	          style: {
	            cursor: 'e-resize',
	            width: '100vw'
	          }
	        },
	        imageToShow && _react2.default.createElement(_ProjectImage2.default, { src: imageToShow.asset.file.url })
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	exports.default = Project;
	
	
	Project.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-ProjectImages----styles-module---wrapper---V9-MI"};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProjectImages = __webpack_require__(203);
	
	var _ProjectImages2 = _interopRequireDefault(_ProjectImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectImagePage = function ProjectImagePage(_ref) {
	  var data = _ref.data,
	      history = _ref.history;
	  return _react2.default.createElement(_ProjectImages2.default, { data: data, history: history });
	};
	
	exports.default = ProjectImagePage;
	
	
	ProjectImagePage.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-images-index-jsx-5beaeee4d29005787212.js